import * as yup from 'yup';

const daysMessage = 'Days should be between 0-7 days';
const hoursMessage = 'Hours should be between 0-23 hours';
const minLookbackMessage = 'Should be no less than 3 hours';

const periodShape = yup.object({
  isCustom: yup.boolean().required(),
  days: yup
    .number()
    .min(0, daysMessage)
    .max(7, daysMessage)
    .required('Days is required'),
  hours: yup
    .number()
    .min(0, hoursMessage)
    .max(23, hoursMessage)
    .required('Hours is required')
    .when('days', {
      is: 0,
      then: (schema) => schema.min(3, minLookbackMessage).max(23, hoursMessage),
      otherwise: (schema) => schema.min(0, hoursMessage).max(23, hoursMessage),
    }),
});

export const lookbackPeriodValidationSchema = yup.object({
  cpu: periodShape,
  memory: periodShape,
});
